/* JJ Monaghan collection page: live filtering, filter dropdowns and the phone filter sheet. Falls back to normal page loads. */
(function () {
  'use strict';
  var root = document.querySelector('[data-jjm-coll]');
  if (!root || root.__jjmColl) return;
  root.__jjmColl = true;

  var form = root.querySelector('[data-jjm-form]');
  var desktop = window.matchMedia('(min-width: 960px)');
  var seq = 0;
  var timer = null;
  var controller = null;

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---------- Dropdowns (desktop) and accordions (phone) ---------- */
  function placePanel(dd) {
    var panel = $('.jjm-coll__panel', dd);
    if (!panel) return;
    panel.classList.remove('is-right');
    if (!desktop.matches) return;
    var r = panel.getBoundingClientRect();
    if (r.right > window.innerWidth - 8) panel.classList.add('is-right');
  }
  function closeOthers(except) {
    $$('.jjm-coll__dd[open]').forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
  }
  root.addEventListener('toggle', function (e) {
    var dd = e.target;
    if (!dd.classList || !dd.classList.contains('jjm-coll__dd') || !dd.open) return;
    closeOthers(dd);
    placePanel(dd);
  }, true);
  document.addEventListener('click', function (e) {
    if (!desktop.matches) return;
    if (!e.target.closest || e.target.closest('.jjm-coll__dd')) return;
    closeOthers(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (root.classList.contains('is-sheet')) { closeSheet(); return; }
    var open = $('.jjm-coll__dd[open]');
    if (open) { open.removeAttribute('open'); var s = $('summary', open); if (s) s.focus(); }
  });

  /* ---------- Phone sheet ---------- */
  var opener = $('[data-jjm-open]');
  function openSheet() {
    root.classList.add('is-sheet');
    document.documentElement.classList.add('jjm-coll-lock');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var x = $('.jjm-coll__sheet-x');
    if (x) x.focus();
  }
  function closeSheet() {
    root.classList.remove('is-sheet');
    document.documentElement.classList.remove('jjm-coll-lock');
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
  }
  if (desktop.addEventListener) {
    desktop.addEventListener('change', function () {
      if (desktop.matches && root.classList.contains('is-sheet')) {
        root.classList.remove('is-sheet');
        document.documentElement.classList.remove('jjm-coll-lock');
      }
    });
  }

  /* ---------- Live update ---------- */
  function currentUrl() {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var qs = params.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }

  function swap(sel, doc) {
    var a = $(sel), b = doc.querySelector(sel);
    if (a && b) a.innerHTML = b.innerHTML;
  }

  function apply(doc) {
    var newRoot = doc.querySelector('[data-jjm-coll]');
    if (!newRoot) throw new Error('no root');

    var openKeys = $$('.jjm-coll__dd[open]').map(function (d) { return d.getAttribute('data-key'); });
    var scroller = $('.jjm-coll__scroll');
    var top = scroller ? scroller.scrollTop : 0;
    var focusId = null;
    var ae = document.activeElement;
    if (ae && ae.name && root.contains(ae) && ae.type === 'checkbox') focusId = ae.name + '|' + ae.value;

    swap('[data-jjm-groups]', newRoot);
    swap('[data-jjm-chips]', newRoot);
    swap('[data-jjm-results]', newRoot);

    $$('[data-jjm-count]').forEach(function (el, i) {
      var src = newRoot.querySelectorAll('[data-jjm-count]')[i];
      if (src) el.textContent = src.textContent;
    });
    var show = $('[data-jjm-show]'), newShow = newRoot.querySelector('[data-jjm-show]');
    if (show && newShow) show.textContent = newShow.textContent;
    var badge = $('[data-jjm-badge]'), newBadge = newRoot.querySelector('[data-jjm-badge]');
    if (badge && newBadge) { badge.textContent = newBadge.textContent; badge.hidden = newBadge.hidden; }

    $$('.jjm-coll__dd').forEach(function (d) {
      if (openKeys.indexOf(d.getAttribute('data-key')) > -1) { d.setAttribute('open', ''); }
    });
    if (scroller) scroller.scrollTop = top;
    if (focusId) {
      var again = $$('input[type="checkbox"]').filter(function (i) { return i.name + '|' + i.value === focusId; })[0];
      if (again && !again.disabled) again.focus();
    }
  }

  function withView(url) {
    var v = root.getAttribute('data-view');
    if (v && url.indexOf('view=') < 0) url += (url.indexOf('?') < 0 ? '?' : '&') + 'view=' + encodeURIComponent(v);
    return url;
  }

  function update(url, push) {
    url = withView(url);
    var mine = ++seq;
    if (controller && controller.abort) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    var results = $('[data-jjm-results]');
    if (results) results.classList.add('is-loading');
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', signal: controller ? controller.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('bad'); return r.text(); })
      .then(function (html) {
        if (mine !== seq) return;
        apply(new DOMParser().parseFromString(html, 'text/html'));
        if (push !== false) history.pushState({ jjmColl: true }, '', url);
        var r2 = $('[data-jjm-results]');
        if (r2) r2.classList.remove('is-loading');
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  /* ---------- Events ---------- */
  function queue() {
    clearTimeout(timer);
    timer = setTimeout(function () { update(currentUrl()); }, 160);
  }
  if (form) {
    form.addEventListener('change', queue);
    form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); update(currentUrl()); });
  }

  function clearAll() {
    $$('input[type="checkbox"]', form).forEach(function (i) { i.checked = false; });
    $$('input[type="number"]', form).forEach(function (i) { i.value = ''; });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentNode;
    var a;
    if ((a = t.closest('[data-jjm-open]'))) { openSheet(); return; }
    if ((a = t.closest('[data-jjm-close]'))) { closeSheet(); return; }
    if ((a = t.closest('[data-jjm-clear-group]'))) {
      var dd = a.closest('.jjm-coll__dd');
      $$('input[type="checkbox"]', dd).forEach(function (i) { i.checked = false; });
      $$('input[type="number"]', dd).forEach(function (i) { i.value = ''; });
      queue();
      return;
    }
    if ((a = t.closest('[data-jjm-clear]'))) {
      if (!form) return;
      e.preventDefault();
      clearAll();
      clearTimeout(timer);
      update(currentUrl());
      return;
    }
    if ((a = t.closest('a[data-jjm-ajax]'))) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      update(a.getAttribute('href'));
    }
  });

  window.addEventListener('popstate', function () {
    if (location.search !== undefined) update(location.pathname + location.search, false);
  });
})();